import { cn } from '@client/lib/utils';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showDot?: boolean;
  collapsed?: boolean;
  variant?: 'default' | 'light';
  className?: string;
}

const sizeClasses = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-2xl',
};

const dotSizes = {
  sm: 'w-1 h-1',
  md: 'w-1.5 h-1.5',
  lg: 'w-2 h-2',
};

const dotOffsets = {
  sm: '-top-0.5 -right-0.5',
  md: '-top-0.5 -right-0.5',
  lg: '-top-1 -right-0.5',
};

export function Logo({ size = 'md', showDot = true, collapsed = false, variant = 'default', className }: LogoProps) {
  if (collapsed) {
    return (
      <div className={cn('flex items-center justify-center', className)}>
        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
          <div className="w-2.5 h-2.5 rounded-full bg-primary" />
        </div>
      </div>
    );
  }

  return (
    <span
      className={cn(
        'font-display font-bold tracking-tight select-none inline-flex items-baseline',
        sizeClasses[size],
        className,
      )}
    >
      {/* On dark surfaces (the site, the sidebar) the brighter turquoise of the public site. */}
      <span className={variant === 'light' ? 'text-[#47f6d8]' : 'text-[color:var(--primary)]'}>chat</span>
      <span className={variant === 'light' ? 'text-white relative' : 'text-foreground relative'}>
        nutr
        <span className="relative inline-block">
          {/* The letter "i" without its default dot — we replace the dot */}
          <span>i</span>
          {showDot && (
            <span
              className={cn(
                'absolute rounded-full',
                variant === 'light' ? 'bg-[#47f6d8]' : 'bg-primary',
                dotSizes[size],
                dotOffsets[size],
              )}
            />
          )}
        </span>
      </span>
    </span>
  );
}
